import UrlPattern from 'url-pattern';
import mapValues from 'lodash/mapValues';

const routePaths = {
  login: '/login',
  logout: '/logout',
  messages: '/messages/:page',
  message: '/message/:id',
  loan: '/loan',
  admins: '/admins',
  loanConsultants: '/loan-consultants',
  financingRequests: '/financing-requests/:page',
  initTwoFA: '/init-two-fa',
  projects: '/projects/:page',
  reports: '/reports',
  customerDataAnalytics: '/customer-data-analytics/:page',
  loginTwoFA: '/login-two-fa',
  notifications: '/notifications',
  co2SavingsReport: '/co2-savings-report',
  co2SavingsByProjects: '/co2-savings-by-projects/:page',
  hypoNoeApiRequestsReport: '/hypo-noe-api-requests-report/:page',
  expressLoanSettings: '/express-loan-settings',
};

export type TRouteName = keyof typeof routePaths;

export const routePatterns = mapValues(routePaths, (pattern) => new UrlPattern(pattern));

const routePathsWithDefault = {
  ...routePaths,
  default: routePatterns.projects.stringify({ page: 1 }),
};

export default routePathsWithDefault;
